<template>
  <div>
    <div class="box news-box" id="popularScienceKnowledge">
      <div class="sub-nav">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>科普知识</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="new-wrapper">
        <div class="left-box fl">
          <div
            :class="activeIndex == 1 ? 'left-box-title-noSelected active' : 'left-box-title-noSelected'"
            @click="tab(1)"
          >
            <div class="left-box-title-main">
              <!-- <img src="../../assets/images/s.png" alt /> -->
              <svg-icon icon-class="植物资源管理" size="24" :className="activeIndex == 1 ? 'activeIcon':'icon'"></svg-icon>
              <span>水土保持植物资源</span>
            </div>
            <img class="bj" src="../../assets/images/right.png" alt />
          </div>
          <div
            :class="activeIndex == 2 ? 'left-box-title-noSelected active' : 'left-box-title-noSelected'"
            @click="tab(2)"
          >
            <div class="left-box-title-main">
              <svg-icon icon-class="灾害预警管理" size="24" :className="activeIndex == 2 ? 'activeIcon':'icon'"></svg-icon>
              <span>水土保持灾害预案</span>
            </div>
            <img class="bj" src="../../assets/images/right.png" alt />
          </div>
          <div
            :class="activeIndex == 3 ? 'left-box-title-noSelected active' : 'left-box-title-noSelected'"
            @click="tab(3)"
          >
            <div class="left-box-title-main">
              <svg-icon icon-class="科研成果管理" size="24" :className="activeIndex == 3 ? 'activeIcon':'icon'"></svg-icon>
              <span>科研成果</span>
            </div>
            <img class="bj" src="../../assets/images/right.png" alt />
          </div>
          <div
            :class="activeIndex == 4 ? 'left-box-title-noSelected active' : 'left-box-title-noSelected'"
            @click="tab(4)"
          >
            <div class="left-box-title-main">
              <svg-icon icon-class="相关会议管理" size="24" :className="activeIndex == 4 ? 'activeIcon':'icon'"></svg-icon>
              <span>相关会议</span>
            </div>
            <img class="bj" src="../../assets/images/right.png" alt />
          </div>
        </div>
        <div class="right-box fn-box fr">
          <ul v-if="activeIndex == 1">
            <li
              @click="handelTurnDetail(item)"
              class="top"
              v-for="(item,index) in tableData"
              :key="index"
            >
              <div>
                <span class="fl left m-img">
                  <img :src="publicPath+item.thumbnail" alt />
                </span>
                <div class="fl right">
                  <div class="m-main">
                    <p class="m-title" :title="item.name">{{item.name}}</p>
                    <p >{{item.briefIntroduction}}</p>
                    <a href="javascript:void(0);" @click="handelTurnDetail(item)">查看详情></a>
                  </div>
                </div>
              </div>
              <div class="clear"></div>
            </li>
          </ul>
          <ul v-else>
            <li
              @click="handelTurnDetail(item)"
              class="normal"
              v-for="(item,index) in tableData"
              :key="index"
            >
              <div>
                <span class="fl" v-if="activeIndex == 2 || activeIndex == 4">{{item.name}}</span>
                <span class="fl" v-if="activeIndex == 3">{{item.title}}</span>
                <span class="fr">
                  <span class="source" v-if="activeIndex == 3 && item.type == 1">科研站所</span>
                  <span class="source" v-if="activeIndex == 3 && item.type == 2">科技文献</span>
                  <span class="source" v-if="activeIndex == 3 && item.type == 3">科技报告讲座</span>
                  <span class="source" v-if="activeIndex == 3 && item.type == 4">行业规范标准</span>
                  <span>{{item.createTime | dateFormat }}</span>
                </span>
              </div>
              <div class="clear"></div>
            </li>
          </ul>
          <div class="page">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="query.current"
              :page-sizes="[10, 20, 50, 100,500]"
              :page-size="query.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.total"
              background
            ></el-pagination>
          </div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>
<script>
import {
  getRelevantMeetingsPage,
  getAchievementsPage,
  getDisasterPlanPage,
  getPlantResourcesPage
} from "../../api/index";
export default {
  name: "",
  data() {
    return {
      publicPath:window.publicPath,
      query: {
        current: 1,
        size: 10,
        title: "",
        type: 1
      },
      fullHeight: document.documentElement.clientHeight,
      page: {
        total: 0
      },
      tableData: [],
      activeIndex: 1
    };
  },
  created() {
    this.activeIndex = this.$route.query.openId || 1;
    this.getData();
  },
  filters: {
			//将时间戳过滤为正常日期格式
			dateFormat: function (data) {
        if(!data){
          return;
        }
			  var date = new Date(data.replace(/-/g,"/")).Format("yyyy-MM-dd");
			  return date;
			}
	},
  methods: {
    tab(type) {
      this.activeIndex = type;
      this.query = {
        current: 1,
        size: 10,
        title: "",
        type: type
      };
      this.getData();
    },
    getData() {
      if (this.activeIndex == 1) {
        getPlantResourcesPage(this.query).then(res => {
          this.tableData = res.data.records;
          this.page.total = res.data.total || 0;
        });
      }
      if (this.activeIndex == 2) {
        getDisasterPlanPage(this.query).then(res => {
          this.tableData = res.data.records;
          this.page.total = res.data.total || 0;
        });
      }
      if (this.activeIndex == 3) {
        getAchievementsPage(this.query).then(res => {
          this.tableData = res.data.records;
          this.page.total = res.data.total || 0;
        });
      }
      if (this.activeIndex == 4) {
        getRelevantMeetingsPage(this.query).then(res => {
          this.tableData = res.data.records;
          this.page.total = res.data.total || 0;
        });
      }
    },
    handleSizeChange(val) {
      this.$set(this.query, "size", val);
      this.getData();
    },
    handleCurrentChange(val) {
      this.$set(this.query, "current", val);
      this.getData();
    },
    handelTurnDetail(row) {
      this.$router.push({
        path: "/popularScienceKnowledgeDetail/" + row.id,
        query: {
          openId: this.activeIndex
        }
      });
    }
  }
};
</script>

<style lang="" >
.activeIcon{
 color: #ffffff;
}
.icon{
  color: #01ADD6;
}
</style>


// WEBPACK FOOTER //
// src/views/popularScienceKnowledge/index.vue